import {FormInput} from "./form.input.c";
import {FormDropdown} from "./form.dropdown.c";

export const Form = {
	Input: FormInput,
	Dropdown: FormDropdown
}
